import * as Yup from "yup";

export const ContractorCompanyFormSchema = Yup.object().shape({
  name: Yup.string().required("Company name is required"),
});
